import { AppPromoContentModule } from '@silvertours/common-landingpages-view';
import { useTranslations } from 'next-intl';

export const useAppPromoModuleDefaults = (): AppPromoContentModule => {
  const t = useTranslations('features.appPromoModule');

  return {
    moduleType: 'appPromoModule',
    badge: { text: t('badge') },
    heading: { text: t('heading') },
    features: Object.values(t.raw('features') as Record<string, string>),
    illustrationTextDesktop: t('illustrationTextDesktop'),
    illustrationTextMobile: t('illustrationTextMobile'),
    aboutText: t('aboutText'),
  };
};
